export default "__VITE_ASSET__e4e8fd14__"